import { HIDE_TOOLBAR, SHOW_TOOLBAR, ADD_DATA_ITEM, CHANGE_DATA_TITLE, CHANGE_SELECTED_ITEM, CHANGE_DATA_TAGS } from '@reduxLocal/actions/types';
import { store } from '@reduxLocal/persistState';

export function dispatchToolbar() {
  return store.dispatch({
    type: SHOW_TOOLBAR,
    payload: {
      draggable: true,
      historyTracked: true,
      items: [
        { id: 'string', toolName: 'Text', icon: 'card-text', description: 'Can be used to enter text and customisable to required parameters' },
        { id: 'number', toolName: 'Number', icon: 'format-list-numbered', description: 'Can be used to restrict entry to numbers only and within a certain range if required' },
        { id: 'dropdown', toolName: 'Dropdown', icon: 'form-dropdown', description: 'A dropdown object that can be used to restrict available options' },
        { id: 'image', toolName: 'Image', icon: 'image', description: 'Can be used to upload images' },
        { id: 'boolean', toolName: 'Yes/No', icon: 'radiobox-marked', description: 'A number of options available including radio buttons, sliders, and others to indicate a yes or no answer' },
        { id: 'date', toolName: 'Date', icon: 'calendar', description: 'Can be used to enter the date' },
        { id: 'location', toolName: 'Location', icon: 'map-marker', description: 'Can be used to enter location' },
        { id: 'switch', toolName: 'Switch', icon: 'toggle-switch', description: 'A switch component for toggling between two states' },
        { id: 'slider', toolName: 'Slider', icon: 'slide', description: 'A slider component for selecting a value within a range' },
        { id: 'checkbox', toolName: 'Checkbox', icon: 'checkbox-marked', description: 'A checkbox component for selecting multiple options' },
        { id:'checkGroup', toolName: 'Checkbox Group', icon: 'checkbox-multiple-marked', description: 'A group of checkboxes for selecting multiple options' },
        { id: 'textarea', toolName: 'Textarea', icon: 'text-box', description: 'A textarea component for multiline text input' },
        { id: 'file', toolName: 'File Upload', icon: 'file-upload', description: 'A file upload component for uploading files' },
        { id: 'dataSet', toolName: 'Data Set', icon: 'database', description: 'Connect or reference other data sets' },
        { id: 'color', toolName: 'Color Picker', icon: 'palette', description: 'A color picker component for selecting colors' },
        { id: 'button', toolName: 'Button', icon: 'gesture-tap-button', description: 'A button component for triggering actions' },
        { id: 'map', toolName: 'Map', icon: 'map-search-outline', description: 'A map component for displaying locations' },
        { id: 'video', toolName: 'Video', icon: 'video', description: 'A video component for displaying videos' },
        { id: 'audio', toolName: 'Audio', icon: 'music-note', description: 'An audio component for playing audio files' },
        { id: 'table', toolName: 'Table', icon: 'table', description: 'A table component for displaying tabular data' },
        { id: 'chart', toolName: 'Chart', icon: 'chart-bar', description: 'A chart component for displaying data visually' },
        { id: 'customComponent', toolName: 'Custom', icon: 'cube-outline', description: 'A custom component for advanced use cases' },
      ],
    },
  });

}

export function dispatchUserToolbar() {
  return store.dispatch({
    type: SHOW_TOOLBAR,
    payload: {
      draggable: false,
      historyTracked: false,
      component: 'user',
      refId: 'userRefId',
      items: [
        { id: 'addUser', toolName: 'Add User', icon: 'account-plus', description: 'Add a user to the system' },
        { id: 'zoomIn', toolName: 'Zoom In', icon: 'magnify-plus', description: 'Zoom in on the map' },
        { id: 'zoomOut', toolName: 'Zoom Out', icon: 'magnify-minus', description: 'Zoom out on the map' },
        { id: 'centerView', toolName: 'Center', icon: 'crosshairs-gps', description: 'Center the view on the map' },
        { id: 'settings', toolName: 'Settings', icon: 'cog', description: 'Open the settings menu' },
        { id: 'help', toolName: 'Help', icon: 'help-circle', description: 'Open the help menu' },
      ]
    }
  })
}